export const SAVE_RECORDINGS = 'SAVE_RECORDINGS';
export const CLEAR_RECORDINGS = 'CLEAR_RECORDINGS';
